import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { NOTIFICATION_NO_CHANGES } from '../../../../constants/notification'
import { getNotificationNoChanged } from '../../../../utils/notification'
import { FORM_FIELD_NAME_NO_CHANGED } from '../../Form.constants'

export function useFormNoChangesNotification({
  errors,
  onRemoveNotification,
  onSetNotification,
}) {
  const { t } = useTranslation()

  useEffect(() => {
    if (errors[FORM_FIELD_NAME_NO_CHANGED]) {
      onSetNotification(getNotificationNoChanged(t))
    } else {
      onRemoveNotification(NOTIFICATION_NO_CHANGES)
    }
  }, [errors])
}
